import { gql, TypedDocumentNode } from "@apollo/client";
import { FacilityCourseType, FacilityOperatingStatus, FacilityOperationType, FacilityType } from "@/types";

export type CreateFacilityAddressInput = {
  address1: string;
  address2?: string;
  city: string;
  state?: string;
  postalCode?: string;
  countryCode: string;
  isVerified?: boolean;
  addressType: string;
};

export type CreateFacilityInput = {
  name: string;
  mainAddress?: CreateFacilityAddressInput | null;
  mailingAddress?: CreateFacilityAddressInput | null;
  website?: string | null;
  phone?: string | null;
  fax?: string | null;
  golfShopPhone?: string | null;
  facilityType?: FacilityType | null;
  courseType?: FacilityCourseType | null;
  operationType?: FacilityOperationType | null;
  operatingStatus?: FacilityOperatingStatus | null;
  parentCompanyId?: string | null;
  generalManagerName?: string | null;
  managementGroup?: string | null;
  sectionId: string;
  chapterId?: string | null;
  holesInRegulation?: number | null;
  practiceRangeAvailable?: boolean | null;
  simulatorAvailable?: boolean | null;
  lengthOfSeasonInMonths?: number | null;
  golfCartBrand?: string | null;
  membershipTotal?: number | null;
  membershipMen?: number | null;
  membershipWomen?: number | null;
  membershipJunior?: number | null;
  membershipSenior?: number | null;
};

export type CreateFacilityResponse = {
  createFacility: {
    success: boolean;
    message: string;
    facility: { id: string; name: string } | null;
  };
};

export const CREATE_FACILITY_MUTATION: TypedDocumentNode<CreateFacilityResponse, { input: CreateFacilityInput }> = gql`
  mutation CreateFacility($input: BackofficeCreateFacilityInput!) {
    createFacility(input: $input) {
      success
      message
      facility {
        id
        name
      }
    }
  }
`;
